import api from "@/services/api";
import { ENDPOINTS } from "@/constants/endpoints";

export default {
  async getAdvertisements() {
    try {
      const { data } = await api.get(ENDPOINTS.advertisements);
      return Promise.resolve(data);
    } catch (e) {
      return Promise.reject(e);
    }
  },
};
